export const PHONE_XS = "20em";
export const PHONE = "37.5em";
export const TAB_PORT = "56.25em";
export const TAB_LAND = "75em";
export const BIG_DESKTOP = "112.5em";